import React from "react";
import "./style.css";

const Container = ({ children }) => (
    <>
        <main className="container">{children}</main>
    </>
);

export default Container;